import React, { useState } from "react";
import styles from "./Sidebar.module.scss";
import { useCustomState } from "../../../state/state";
import { Button, Link, LinkS, Logo } from "../../elements";
import { Backdrop } from "../../ui";
import THEME from "../../../state/theme";
import logo_bleu from '../../../assets/images/logo_bleu.svg';

export default ({ data = [] }) => {
  const [state, actions] = useCustomState();
  const [submenu, setSubmenu] = useState(null);

  const hover = {
    color: THEME.color,
  };

  const toogleSubmenu = (index) => {
    index === submenu ? setSubmenu(null) : setSubmenu(index);
  };

  const toogleSidebar = () => {
    actions.toogleSidebar();
    state.backdrop && actions.toogleBackdrop();
  };

  const toogleModal = () => {
    actions.toogleModal();
    actions.toogleSidebar();
  };

  const menu = data.map((item, index) => {
    if (!item.children) {
      return (
        <li key={index}>
          <LinkS click={toogleSidebar} url={item.url} hoverStyle={hover}>
            {item.name}
          </LinkS>
        </li>
      );
    } else {
      return (
        <li key={index}>
          <span>
            <LinkS url="#" hoverStyle={hover} click={() => toogleSubmenu(index)} style={{color: THEME.blue_structurea}}>
              {item.name}
              <i
                className={
                  submenu === index ? "las la-angle-up" : "las la-angle-down"
                }
                onClick={() => toogleSubmenu(index)}
              />
            </LinkS>
          </span>
          <ul
            style={{
              height:
                submenu === index ? 30 * item.children.length + "px" : "0",
            }}
          >
            {item.children.map((subitem, subindex) => (
              <li key={subindex}>
                <LinkS
                  click={toogleSidebar}
                  url={subitem.url}
                  hoverStyle={hover}
                  style={{color: THEME.blue_structurea}}
                >
                  {subitem.name}
                </LinkS>
              </li>
            ))}
          </ul>
        </li>
      );
    }
  });

  return (
    <div className={[styles.wrapper, state.sidebar && styles.show].join(" ")}>
      <div className={styles.sidebar}>
        <div className={styles.btn_close} onClick={toogleSidebar}>
          <Button
            after="&#xf00d;"
            type="solid-white-tb"
            hoverType="solid-gray-tb"
          />
        </div>
        <div className={styles.logo}>
          <Logo logo={logo_bleu}/>
        </div>

        <ul className={styles.menu}  >{menu}</ul>
        <div className={styles.btn_contacts}>
          <Button hoverType="solid-gray-tb" click={toogleModal}>
            ENVOYER MESSAGE
          </Button>
        </div>
      </div>
      <Backdrop />
    </div>
  );
};
